module.exports = __webpack_public_path__ + "assets/resstar2-1at2x.4360e43abefd4943d1bc1b0fdede1745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar2-1at2x.png
// module id = 855
// module chunks = 0